import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import PublicLayout from "@/components/public/PublicLayout";
import Seo from "@/components/public/Seo";
import { PageHero } from "@/components/public/blocks";

export default function Legal({ kind }) {
  const { t } = useTranslation();
  const title = t(kind === "privacy" ? "site.legal.privacyTitle" : "site.legal.termsTitle");
  return (
    <PublicLayout testId={`${kind}-page`}>
      <Seo path={`/${kind}`} title={`${title} | Drivons Market`} description={t("site.legal.pendingBody")} noindex />
      <PageHero title={title} />
      <section className="max-w-3xl mx-auto px-5 pb-24">
        <div className="rounded-2xl border border-dashed border-brand/50 bg-brand/5 p-8" data-testid={`${kind}-placeholder`}>
          <FileText className="w-6 h-6 text-brand" aria-hidden="true" />
          <p className="font-display font-bold text-lg mt-3">{t("site.legal.pending")}</p>
          <p className="text-slate-400 mt-2">{t("site.legal.pendingBody")}</p>
          <Link to="/support" className="inline-block mt-5 text-brand font-semibold hover:underline underline-offset-4" data-testid={`${kind}-support-link`}>{t("nav.support")}</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
